import type { ReactNode } from 'react'

/** Sessions à gauche, attestations à droite : la disposition de la fiche, partagée avec sa démonstration (#242). */
function ProfileActivityGrid({ sessions, certificates }: { sessions: ReactNode, certificates: ReactNode }) {
  return (
    // Côte à côte seulement quand le tableau des sessions y tient ; `min-w-0` le laisse défiler
    // dans sa carte au lieu d'élargir la colonne (un élément de grille vaut au moins son contenu).
    <div className="grid gap-4 2xl:grid-cols-[2fr_1fr]">
      <div className="min-w-0">{sessions}</div>
      <div className="min-w-0">{certificates}</div>
    </div>
  )
}

export default ProfileActivityGrid
